export const DEFAULT_OPTIONS_MENU_SIDE = ['home'];

export const enum ROUTES {
  HOME = '/home',
  DASHBOARD = '/dashboard',
  //ai
  GREENFY_AI = '/greenfy-ai',
  SETTINGS_AI = '/settings-ai',
  ADD_FILES_AI = '/add-files-ai',
  EDIT_FILES_AI = '/edit-files-ai',
  LIST_FILES_AI = '/list-files-ai',

  // report
  REPORT_INPUT = '/report-input',
  REPORT_PRODUCTION = '/report-production',
  REPORT_FINANCE = '/report-finance',

  //producution
  //farm
  PONDS = '/ponds',
  POND = '/pond/',
  POND_ID = '/pond/:id',

  //SUPPLIES
  SUPPLIES = '/supplies',
  SUPPLY = '/supply/',
  SUPPLIES_ID = '/supply/:id',

  //Cycles
  CYCLES = '/cycles',
  CYCLE = '/cycle/',
  CYCLE_ID = '/cycle/:id',

  //population
  POPULATIONS = '/populations',
  POPULATION = '/population/',
  POPULATION_ID = '/population/:id',

  //transfers
  TRANSFERS = '/transfers',
  TRANSFER = '/transfer/',
  TRANSFER_ID = '/transfer/:id',

  //inputs
  INPUTS = '/inputs',
  INPUT = '/input/',
  INPUT_ID = '/input/:id',

  //measurements
  MEASUREMENTS = '/measurements',
  MEASUREMENT = '/measurement/',
  MEASUREMENT_ID = '/measurement/:id',

  //   biomeasures
  BIOMEASURES = '/biomeasures',
  BIOMEASURE = '/biomeasure/',
  BIOMEASURE_ID = '/biomeasure/:id',

  //analysis
  ANALYSIS = '/analysis',
  ANALYSE = '/analyse/',
  ANALYSIS_ID = '/analyse/:id',

  //mortalities
  MORTALITIES = '/mortalities',
  MORTALITY = '/mortality/',
  MORTALITY_ID = '/mortality/:id',

  //harvests
  HARVESTS = '/harvests',
  HARVEST = '/harvest/',
  HARVEST_ID = '/harvest/:id',

  //stocks
  STOCKS = '/stocks',
  STOCK = '/stock/',
  STOCK_ID = '/stock/:id',

  //lots
  LOTS = '/lots',
  LOT = '/purchase/',
  LOT_ID = '/lot/:id',

  //parameters
  PARAMETERS = '/parameters',
  PARAMETER = '/parameter/',
  PARAMETER_ID = '/parameter/:id',

  //unities
  UNITIES = '/unities',
  UNITY = '/unity/',
  UNITY_ID = '/unity/:id',
  CUSTOM_UNIT = '/custom-unit/',

  //forms
  FORMS = '/forms',
  FORM = '/form/',
  FORM_ID = '/form/:id',

  //providers
  PROVIDERS = '/providers',
  PROVIDER = '/provider/',
  PROVIDER_ID = '/provider/:id',

  //purchases
  PURCHASES = '/purchases',
  PURCHASE = '/purchase/',
  PURCHASE_ID = '/purchase/:id',

  //accounts-center
  ACCOUNTS_CENTER = '/accounts-center',
  ACCOUNT_CENTER = '/account-center/',
  ACCOUNT_CENTER_ID = '/account-center/:id',

  //pay-bills
  PAY_BILLS = '/pay-bills',
  PAY_BILL = '/pay-bill/',
  PAY_BILL_ID = '/pay-bill/:id',

  //receive-bills
  RECEIVE_BILLS = '/receive-bills',
  RECEIVE_BILL = '/sale/',
  RECEIVE_BILL_ID = '/sale/:id',

  //bank-accounts
  BANK_ACCOUNTS = '/bank-accounts',
  BANK_ACCOUNT = '/bank-account/',
  BANK_ACCOUNT_ID = '/bank-account/:id',

  //transactions
  TRANSACTIONS = '/transactions',
  TRANSACTION = '/transaction/',
  TRANSACTION_ID = '/transaction/:id',

  //clients
  CLIENTS = '/clients',
  CLIENT = '/client/',
  CLIENT_ID = '/client/:id',

  //sales
  SALES = '/sales',
  SALE = '/sale/',
  SALE_ID = '/sale/:id',

  //users
  USERS = '/users',
  USER = '/user/',
  USER_ID = '/user/:id',

  //instructions
  INSTRUCTIONS = '/instructions',
}

export const OPTIONS: Record<ROUTES, string[]> = {
  '/home': ['home'],
  '/dashboard': ['dashboard'],

  //ai
  '/greenfy-ai': ['ai'],
  '/settings-ai': ['settings-ai'],
  '/add-files-ai': ['add-files-ai'],
  '/edit-files-ai': ['edit-files-ai'],
  '/list-files-ai': ['list-files-ai'],

  // report
  '/report-input': ['report-input'],
  '/report-production': ['report-production'],
  '/report-finance': ['report-finance'],

  //producution
  //farm
  '/ponds': ['ponds'],
  '/pond/': ['pond'],
  '/pond/:id': ['pondId'],

  //SUPPLIES
  '/supplies': ['supplies'],
  '/supply/': ['supply'],
  '/supply/:id': ['supplyId'],

  //Cycles
  '/cycles': ['cycles'],
  '/cycle/': ['cycle'],
  '/cycle/:id': ['cycleId'],

  //population
  '/populations': ['populations'],
  '/population/': ['population'],
  '/population/:id': ['populationId'],

  //transfers
  '/transfers': ['transfers'],
  '/transfer/': ['transfer'],
  '/transfer/:id': ['transferId'],

  //inputs
  '/inputs': ['inputs'],
  '/input/': ['input'],
  '/input/:id': ['inputId'],

  //measurements
  '/measurements': ['measurements'],
  '/measurement/': ['measurement'],
  '/measurement/:id': ['measurementId'],

  //   biomeasures
  '/biomeasures': ['biomeasures'],
  '/biomeasure/': ['biomeasure'],
  '/biomeasure/:id': ['biomeasureId'],

  //analysis
  '/analysis': ['analysis'],
  '/analyse/': ['analyse'],
  '/analyse/:id': ['analyseId'],

  //mortalities
  '/mortalities': ['mortalities'],
  '/mortality/': ['mortality'],
  '/mortality/:id': ['mortalityId'],

  //harvests
  '/harvests': ['harvests'],
  '/harvest/': ['harvest'],
  '/harvest/:id': ['harvestId'],

  //stocks
  '/stocks': ['stocks'],
  '/stock/': ['stock'],
  '/stock/:id': ['stockId'],

  //lots
  '/lots': ['lots'],
  '/purchase/': ['lot', 'purchase'],
  '/lot/:id': ['lotId'],

  //parameters
  '/parameters': ['parameters'],
  '/parameter/': ['parameter'],
  '/parameter/:id': ['parameterId'],

  //unities
  '/unities': ['unities'],
  '/unity/': ['unity'],
  '/unity/:id': ['unityId'],
  '/custom-unit/': ['customUnit'],

  //forms
  '/forms': ['forms'],
  '/form/': ['form'],
  '/form/:id': ['formId'],

  //providers
  '/providers': ['providers'],
  '/provider/': ['provider'],
  '/provider/:id': ['providerId'],

  //purchases
  '/purchases': ['purchases'],
  '/purchase/:id': ['purchaseId'],

  //accounts-center
  '/accounts-center': ['accountsCenter'],
  '/account-center/': ['accountCenter'],
  '/account-center/:id': ['accountCenterId'],

  //pay-bills
  '/pay-bills': ['payBills'],
  '/pay-bill/': ['payBill'],
  '/pay-bill/:id': ['payBillId'],

  //receive-bills
  '/receive-bills': ['receiveBills'],
  '/sale/': ['receiveBill', 'sale'],
  '/sale/:id': ['receiveBillId', 'saleId'],

  //bank-accounts
  '/bank-accounts': ['bankAccounts'],
  '/bank-account/': ['bankAccount'],
  '/bank-account/:id': ['bankAccountId'],

  //transactions
  '/transactions': ['transactions'],
  '/transaction/': ['transaction'],
  '/transaction/:id': ['transactionId'],

  //clients
  '/clients': ['clients'],
  '/client/': ['client'],
  '/client/:id': ['clientId'],

  //sales
  '/sales': ['sales'],

  //users
  '/users': ['users'],
  '/user/': ['user'],
  '/user/:id': ['userId'],

  //instructions
  '/instructions': ['instructions'],
};
